import classnames from 'classnames'

import { NUMBER_SIZE } from '../../../../../constants/size'
import { getQaSelector } from '../../../../../utils/common'
import { Input, InputContainer } from '../../../../Input'
import { QA_NAME_COLOR_PICKER_POPOVER_PREVIEW_INPUT } from '../ColorPickerPopoverPreview.constants'
import {
  isRgbChannelB,
  isRgbChannelG,
  isRgbChannelR,
} from '../ColorPickerPopoverPreview.utils'

import * as styles from '../ColorPickerPopoverPreview.module.css'

function ColorPickerPopoverPreviewRgbInputs({
  groupRef,
  inputRef,
  rgbB,
  rgbFocusedChannel,
  rgbG,
  rgbR,
  onBBlur,
  onBChange,
  onBFocus,
  onGBlur,
  onGChange,
  onGFocus,
  onRBlur,
  onRChange,
  onRFocus,
}) {
  const qaProps = getQaSelector({
    value: QA_NAME_COLOR_PICKER_POPOVER_PREVIEW_INPUT,
  })

  return (
    <div className={styles.rgbInputsRow} ref={groupRef}>
      <InputContainer
        className={styles.rgbChannelInput}
        focused={isRgbChannelR(rgbFocusedChannel)}
        height={NUMBER_SIZE.size24}
      >
        <Input
          {...qaProps}
          className={classnames(styles.valueInput, styles.valueInputRgb)}
          ref={inputRef}
          value={rgbR}
          onBlur={onRBlur}
          onChange={onRChange}
          onFocus={onRFocus}
        />
      </InputContainer>
      <InputContainer
        className={styles.rgbChannelInput}
        focused={isRgbChannelG(rgbFocusedChannel)}
        height={NUMBER_SIZE.size24}
      >
        <Input
          {...qaProps}
          className={classnames(styles.valueInput, styles.valueInputRgb)}
          value={rgbG}
          onBlur={onGBlur}
          onChange={onGChange}
          onFocus={onGFocus}
        />
      </InputContainer>
      <InputContainer
        className={styles.rgbChannelInput}
        focused={isRgbChannelB(rgbFocusedChannel)}
        height={NUMBER_SIZE.size24}
      >
        <Input
          {...qaProps}
          className={classnames(styles.valueInput, styles.valueInputRgb)}
          value={rgbB}
          onBlur={onBBlur}
          onChange={onBChange}
          onFocus={onBFocus}
        />
      </InputContainer>
    </div>
  )
}

export default ColorPickerPopoverPreviewRgbInputs
